module.exports = __webpack_public_path__ + "static/media/incomingcall.86a6250d.wav";